export default "__VITE_ASSET__Bs10Y17d__"